import { FC } from 'react'
import { Typography, Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { EyeOutlined } from '@ant-design/icons'
import styles from './OrderItemDetails.module.scss'
import { BigOrderItem, Order } from 'src/core/models'
import { CustomTag, CustomStatusColumn } from 'src/components'
import { getDateFormatted, getFormatedPrice } from 'src/core/helpers'
const { Title } = Typography
const marketUrl = process.env.MARKET_PLACE_URL

interface OrderItemDetailsProps {
  order: Order
  orderItem: BigOrderItem
}

const OrderItemDetails: FC<OrderItemDetailsProps> = (props) => {
  const { order, orderItem } = props
  const { t } = useTranslation()
  const orderTotal = getFormatedPrice(order.total, orderItem.project_currency_token)

  return (
    <>
      <CustomStatusColumn
        isStatusOk={order.status === 'paid'}
        isCancelled={orderItem.is_cancelled}
      />
      {orderItem.is_vintage && <CustomTag text={`${orderItem.year}`} type={'default'} />}

      <Title className={styles.title}>{orderItem.project_name}</Title>
      <Title level={5} type='secondary'>{getDateFormatted(order.created)}</Title>
      <Title level={5}>{t('Transactions.TotalOrder', { orderTotal })}</Title>
      <br />
      <a rel='noopener noreferrer' href={`${marketUrl}/projects?id=${orderItem.project_id}`}>
        <Button
          type='primary'
          size='large'
          className={`${styles.btnViewProject} radius-100`}
          icon={<EyeOutlined />}
        >
          {t('Transactions.ViewProject')}
        </Button>
      </a>
    </>
  )
}

export default OrderItemDetails
